import { ICubeSchemaMapper } from '../cube-schema-mapper.interface';

export interface IAllScoresMapper extends ICubeSchemaMapper {}
